mutation saveSwap($tx_hash: String, $chain_name: String, $dest_address: String, $tx_id: String) {
  saveSwap(tx_hash: $tx_hash, chain_name: $chain_name, dest_address: $dest_address, tx_id: $tx_id)
}
